/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { GoogleMap, InfoWindow } from '@react-google-maps/api';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import "./Somecss.css";
import { darkMapStyle } from "../../../assets/data/Mapstyle.js";
import NotificationsIcon from '@mui/icons-material/Notifications';
import car_blue from "../../../assets/cms-icons/car_blue.png";
import car_grey from "../../../assets/cms-icons/car_grey.png";
import car_green from "../../../assets/cms-icons/car_green.png";
import car_yellow from "../../../assets/cms-icons/car_yellow.png";
import car_orange from "../../../assets/cms-icons/car_orange.png";
import car_red from "../../../assets/cms-icons/car_red.png";

const MapComponent = ({
  locations,
  givenHeight,
  zoomLevel,
  center: externalCenter,
  zoom: externalZoom,
  selectedVehicle,
  clearSelection,
  mapMode,
}) => {


  const [locations1, setLocations1] = useState([]);
  const [mapInstance, setMapInstance] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    setLocations1([]);
    setLocations1(locations);
  }, [locations]);
  const [heatmapLayer, setHeatmapLayer] = useState(null);
  const [clusterer, setClusterer] = useState(null);
  const [markersRef, setMarkersRef] = useState([]);

  const [center, setCenter] = useState({ lat: 25.2048, lng: 55.2708 });
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [mapKey, setMapKey] = useState(0);
  const [lastMouseLatLng, setLastMouseLatLng] = useState(null);
  const [lastZoom, setLastZoom] = useState(zoomLevel || 14);
  const handleMouseMove = (e) => {
    setLastMouseLatLng({
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
    });
  };
  const handleZoomChanged = () => {
    if (mapInstance) {
      const zoom = mapInstance.getZoom();
      setLastZoom(zoom);
    }
  };
  useEffect(() => {
    if (lastMouseLatLng) {
      setCenter(lastMouseLatLng);
    }
  }, [locations1]);

  const mapContainerStyle = {
    height: givenHeight || '50vh',
    width: '100%'
  };


  useEffect(() => {
    setMapKey(prev => prev + 1);
  }, [locations1]);

  useEffect(() => {
    setSelectedLocation(null); // close InfoWindow
  }, [clearSelection]);
  useEffect(() => {
    if (!mapInstance) return;

    // Clear heatmap
    if (heatmapLayer) {
      heatmapLayer.setMap(null);
      setHeatmapLayer(null);
    }

    // Clear cluster
    if (clusterer) {
      clusterer.clearMarkers();
      setClusterer(null);
    }

    // Clear markers
    if (markersRef.length) {
      markersRef.forEach(marker => marker.setMap(null));
      setMarkersRef([]);
    }

    // MAP MODE → MARKERS + CLUSTER
    if (mapMode === "map") {
      mapInstance.setMapTypeId("roadmap");

      const markers = locations1
        .filter(loc => loc?.position?.lat && loc?.position?.lng)
        .map(loc => {

          const batteryStr = String(loc?.battery_percentage ?? '');
          const [minStr, maxStr] = batteryStr.replace('%', '').split('–');

          const min = parseFloat(minStr);
          const max = parseFloat(maxStr);
          const average = (min + max) / 2;

          let iconUrl = car_blue;

          if (loc?.engineStatus === "On" && average < 15) {
            iconUrl = car_red;
          } else if (loc?.engineStatus === "On" && average < 25) {
            iconUrl = car_orange;
          } else if (loc?.engineStatus === "On" && average < 35) {
            iconUrl = car_yellow;
          } else if (loc?.engineStatus === "On") {
            iconUrl = car_green;
          } else if (loc?.engineStatus === "Off") {
            iconUrl = car_grey;
          }

          const marker = new window.google.maps.Marker({
            position: {
              lat: loc.position.lat,
              lng: loc.position.lng,
            },
            icon: {
              url: iconUrl,
              scaledSize: new window.google.maps.Size(25, 30),
            },
            title: loc?.name,
          });

          marker.addListener("click", () => {
            handleMarkerClick(loc);
          });

          return marker;
        });

      const newClusterer = new MarkerClusterer({
        map: mapInstance,
        markers,
        renderer: {
          render({ count, position }) {

            // Density Based Color Logic
            let fillColor = "#67bb6a";     // Light green (low density)
            let strokeColor = "#4CAF50";

            // if (count >= 20) {
            //   fillColor = "#7b1fa2";       // Purple (high density)
            //   strokeColor = "#6a1b9a";
            // }

            return new window.google.maps.Marker({
              position,
              icon: {
                path: window.google.maps.SymbolPath.CIRCLE,
                fillColor: fillColor,
                fillOpacity: 1,
                strokeColor: strokeColor,
                strokeWeight: 2,
                scale: 18,
              },
              label: {
                text: String(count),
                color: "white",
                fontSize: "14px",
              },
              zIndex: 2,
            });
          },
        },
      });

      setMarkersRef(markers);
      setClusterer(newClusterer);
    }

    // SATELLITE MODE → HEATMAP ONLY
    if (mapMode === "satellite") {
      mapInstance.setMapTypeId("satellite");

      const heatData = locations1
        .filter(loc => loc?.position?.lat && loc?.position?.lng)
        .map(loc =>
          new window.google.maps.LatLng(
            loc.position.lat,
            loc.position.lng
          )
        );

      const newHeatmap =
        new window.google.maps.visualization.HeatmapLayer({
          data: heatData,
          radius: 40,
          opacity: 0.7,
        });

      newHeatmap.setMap(mapInstance);
      setHeatmapLayer(newHeatmap);
    }

  }, [mapMode, locations1, mapInstance]);

  const handleMarkerClick = (location) => {
    setSelectedLocation(location);
  };



  const navigateToNotification = (driverId) => {
    navigate("/push-notifications", { state: driverId });
  }
  useEffect(() => {
    if (!mapInstance) return;

    if (externalCenter?.lat && externalCenter?.lng) {
      setCenter({
        lat: externalCenter.lat,
        lng: externalCenter.lng,
      });

      mapInstance.panTo({
        lat: externalCenter.lat,
        lng: externalCenter.lng,
      });
    }

    if (externalZoom) {
      setLastZoom(externalZoom);
      mapInstance.setZoom(externalZoom);
    }
  }, [externalCenter, externalZoom, mapInstance]);

  useEffect(() => {
    if (!selectedVehicle || !mapInstance) return;

    const lat = selectedVehicle?.position?.lat;
    const lng = selectedVehicle?.position?.lng;

    if (!lat || !lng) return;

    // Pan map
    mapInstance.panTo({ lat, lng });
    mapInstance.setZoom(16);

    // Open InfoWindow
    setSelectedLocation(selectedVehicle);
  }, [selectedVehicle, mapInstance]);


  return (
    <GoogleMap
      key={mapKey}
      mapContainerStyle={mapContainerStyle}
      center={center}
      zoom={lastZoom}
      onZoomChanged={handleZoomChanged}
      onLoad={(map) => setMapInstance(map)}
      onMouseMove={handleMouseMove}
      options={{
        styles: darkMapStyle,
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
          position: window.google.maps.ControlPosition.RIGHT_CENTER,
        },
      }}

    >

      {selectedLocation && (
        <InfoWindow
          position={{ lat: selectedLocation?.position?.lat, lng: selectedLocation?.position?.lng }}
          onCloseClick={() => setSelectedLocation(null)}
        >

          <div style={{ display: "flex", flexDirection: "column", width: "305px" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "0.75rem",
              }}
            >

              <span style={{ fontWeight: "bold", fontSize: "16px" }}>Vehicle Information of {selectedLocation?.name}</span>
              <span style={{ width: "24px" }} />
              <Button variant="icon"
                onClick={() => navigateToNotification(selectedLocation?.driver?.staffId)}
              ><NotificationsIcon fontSize='medium' /></Button>

            </div>
            {/* {selectedLocation?.battery_percentage ? <p style={{ marginBottom: "0.5rem" }}>SOC - {selectedLocation?.battery_percentage} </p> : <p style={{ marginBottom: "0.5rem" }}>SOC - NA </p>} */}
            <p style={{ marginBottom: "0.5rem" }}>Name - {selectedLocation?.driver?.firstName} {selectedLocation?.driver?.lastName}</p>
            <p style={{ marginBottom: "0.5rem" }}>Phone - {selectedLocation?.driver?.phoneNumber}</p>
            <p style={{ marginBottom: "0.5rem" }}>StaffId - {selectedLocation?.driver?.staffId}</p>
            <p style={{ marginBottom: "0.5rem" }}>Engine Status - {selectedLocation?.engineStatus}</p>
            <p style={{ marginBottom: "0.5rem" }}>Passenger Count - {selectedLocation?.passengerCount}</p>
            <p style={{ marginBottom: "0.5rem" }}>VIN - {selectedLocation?.vin}</p>
          </div>
        </InfoWindow>
      )}
    </GoogleMap>
  );
};


export default MapComponent;
